<template>
  <div>
    <breadcrumbs
      :bc-case-id="bcCaseId"
    />
    <b-overlay
      id="overlay-background"
      :show="headerLoader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card
        no-body
      >
        <details-header
          :bc-case-id="bcCaseId"
          :prefix-case-id="prefixCaseId"
        />
      </b-card>
    </b-overlay>
    <hr>
    <b-overlay
      id="overlay-background"
      :show="shiftingdragging"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-row
        class="mt-3"
      >
        <b-col
          sm="12"
          md="7"
          lg="7"
          offset="2"
        >
          <dragable-components
            ref="leftsidecustomization"
            side="Right"
            :places="leftSideComponents"
            :bc-case-id="bcCaseId"
            :prefix-case-id="prefixCaseId"
            :rest-amount="restAmount"
          />
        </b-col>
        <b-col
          sm="12"
          md="5"
          lg="5"
        >
          <dragable-components
            v-if="!caseLoader"
            ref="rightsidecustomization"
            side="Left"
            :places="rightSideComponents"
            :prefix-case-id="prefixCaseId"
            :bc-case-id="bcCaseId"
            :rest-amount="restAmount"
          />
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow, BCol, BOverlay,
  BCard,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import Vue from 'vue'
import constants from '@/app-configs/constants'
import { EventBus } from '@/event-bus'
import Breadcrumbs from './Breadcrumbs.vue'
import DragableComponents from './dragableComponents.vue'
import DetailsHeader from './DetailsHeader.vue'

const sharedState = Vue.observable({
  paymentSettings: {},
  debtorContact: {},
  clientsData: {},
  communicationSettings: {},
  caseStatus: 0,
  paymentOption: '',
  remainingDebtAmount: 0,
})

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BOverlay,
    Breadcrumbs,
    DragableComponents,
    DetailsHeader,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      shiftingdragging: false,
      headerLoader: false,
      caseStatus: 0,
      leftSideComponents: [
        {
          custom_widget_id: null,
          data: null,
          id: 1,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 2,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 9,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 3,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 4,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 5,
          type: 'default',
        },

      ],
      rightSideComponents: [
        {
          custom_widget_id: null,
          data: null,
          id: 6,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 7,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 8,
          type: 'default',
        },
      ],
      caseId: this.$route.params.id,
      bcCaseId: '',
      prefixCaseId: '',
      restAmount: 0,
      state: 'n/a',
      caseLoader: true,
    }
  },
  provide() {
    return {
      sharedState,
    }
  },
  created() {
    this.getDetails()
    EventBus.$on('updateCasesData', () => {
      this.getDetails()
    })
  },
  methods: {
    async getDetails() {
      this.caseLoader = true
      const url = `${constants.baseUrl}/debt-case/${this.caseId}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.bcCaseId = response.data.data.debt_case.bc_case_id
          sharedState.caseStatus = response.data.data.debt_case.status
          sharedState.clientsData = response.data.data.debt_case
          this.prefixCaseId = response.data.data.debt_case.prefix_case_id ? response.data.data.debt_case.prefix_case_id : this.caseId
          this.restAmount = response.data.data.remaining_debt_amount
          sharedState.debtorContact = {
            email: response.data.data.debtor.email,
            phone: response.data.data.debtor.phone,
          }
          sharedState.paymentSettings = {
            client_id: response.data.data.settings.filter(e => e.module === 'payments')[0].client_id,
            secret: response.data.data.settings.filter(e => e.module === 'payments')[0].secret,
          }
          sharedState.communicationSettings = {
            client_id: response.data.data.settings.filter(e => e.module === 'communication')[0].client_id,
            secret: response.data.data.settings.filter(e => e.module === 'communication')[0].secret,
          }
          sharedState.paymentOption = response.data.data.payment_option
          sharedState.remainingDebtAmount = response.data.data.remaining_debt_amount
          this.caseLoader = false
        }
      })
    },
  },
}
</script>

  <style lang="scss">
  @import './detailstyling.scss';
  .draggable-list .list-group-item {
    transition: all 1s ease;
    padding: 0px;
    background-color: #f6f6f6;
    border: none;
    animation-name: shake;
    animation-duration: .20s;
    animation-iteration-count: infinite;
    &:nth-child(even){
      animation-name: shakeeven;
    }
  }
  .case-general-info-plan-active {
    border: 1px solid #00A2E8 !important;
  }
  @keyframes shake {
    0% {
      transform: translate3d(-4px, 0, 0);
    }
    50% {
      transform: translate3d(4px, 0, 0);
    }
    100% {
      transform: translate3d(-4px, 0, 0);
    }
  }
  @keyframes shakeeven {
    0% {
      transform: translate3d(4px, 0, 0);
    }
    50% {
      transform: translate3d(-4px, 0, 0);
    }
    100% {
      transform: translate3d(4px, 0, 0);
    }
  }
  </style>
